import { areViewStatesEqual, type ViewState } from "$lib/controllers/lastView/viewState";
import { Map as LibreMap } from 'maplibre-gl';

export class ViewStateController {
    private _initialState: ViewState;
    private _states: ViewState[] = [];

    constructor(private map: LibreMap, { initialState }: { initialState?: ViewState } = {}) {
        if (initialState) {
            this._initialState = initialState;
        } else {
            this._initialState = this.convertToState();
        }
    }

    add(): void {
        const state: ViewState = this.convertToState();
        const isLatestInStack = this._states.length > 0 && areViewStatesEqual(state, this._states[this._states.length - 1]); // keeping sequential states unique
        const isSameAsInitialState = areViewStatesEqual(state, this._initialState);
        if (isLatestInStack || isSameAsInitialState) {
            console.debug("State is already in the stack", { state, states: this._states, initialState: this._initialState });
            return;
        }
        this._states.push(state);
        console.debug("Added state", { state, states: this._states });
    }

    restore(): void {
        if (this._states.length > 0) {
            console.debug("Restoring found state", { states: this._states });
            const state = this._states.pop()!;
            this.flyToState(state);
        } else {
            console.debug("Restoring inital state", { state: this._initialState });
            this.flyToState(this._initialState);
        }
    }

    clear(): void {
        this._states = [];
    }

    // In case we need to update the map object instead of initialising a whole new object
    update(map: LibreMap): void {
        console.trace("Updating fields");
        this.map = map;
    }

    private convertToState(): ViewState {
        const center = this.map.getCenter();
        return {
            center: { longitude: center.lng, latitude: center.lat },
            zoom: this.map.getZoom(),
            pitch: this.map.getPitch(),
            bearing: this.map.getBearing()
        };
    }

    private flyToState(state: ViewState): void {
        console.debug("Flying to state", { state });
        this.map.flyTo({
            center: { lng: state.center.longitude, lat: state.center.latitude },
            zoom: state.zoom,
            pitch: state.pitch,
            bearing: state.bearing,
            padding: { top: 0, bottom: 0, left: 0, right: 0 },
            essential: true,
            speed: 2.5,
        });
    }
}